/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { carWirelessDuocolor } from "../assets/car-wireless-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconCarWirelessDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={carWirelessDuocolor.svg} />
);

IllustrativeIconCarWirelessDuocolor.displayName = "IllustrativeIconCarWirelessDuocolor";
